import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { TagApiModel } from './tag-api.model';
import { MultiBaseAbstractApi } from '../genericApi/multi-base-abstract.api';


@Injectable()
export class TagsApi extends MultiBaseAbstractApi<TagApiModel, TagApiModel> {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }


    getList(): Observable<TagApiModel[]> {
        const slug: string = '/tags';

        return this.neptuneApi.api<TagApiModel[]>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }


    create(tag: TagApiModel): Observable<number> {
        const slug: string = '/tags';

        return this.neptuneApi.api<number>(
            slug,
            tag,
            HttpVerbsEnum.POST
        );
    }


    update(tag: TagApiModel): Observable<null> {
        const slug: string = `/tags/${tag.id}`;

        return this.neptuneApi.api<null>(
            slug,
            tag,
            HttpVerbsEnum.PUT
        );
    }


    deleteById(id: number): Observable<null> {
        const slug: string = `/tags/${id}`;

        return this.neptuneApi.api<null>(
            slug,
            null,
            HttpVerbsEnum.DELETE
        );
    }

    /** @deprecated Not Implemented */
    getById(id: number): Observable<TagApiModel> {
        return null;
    }
}
